var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightBold(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.173.02c-.648.083-1.24.496-1.508 1.051-.322.666-.201 1.465.303 2 .048.05 2.286 2.021 5.011 4.413l4.925 4.322.026.062c.053.13.055.206.008.282-.01.017-2.223 1.965-4.918 4.329-2.694 2.364-4.941 4.34-4.993 4.39a1.75 1.75 0 00-.27.325c-.3.46-.366 1.027-.182 1.591.065.2.2.451.338.634.186.244.476.451.776.552l.084.029h1.004l.107-.038c.2-.072.388-.177.551-.308.042-.035 2.591-2.285 5.664-5l5.66-5.002a2.11 2.11 0 00.71-1.273c.026-.147.036-.452.02-.615-.052-.516-.271-1.029-.647-1.51C18.777 10.169 7.622.41 7.497.328a1.965 1.965 0 00-.805-.304 2.98 2.98 0 00-.52-.004z",
    fill: "currentColor"
  })));
}
export default SvgArrowRightBold;